import { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { SupplierCreateEditState, SupplierCreateEditReducer, ACTION_TYPES } from './supplier-create-edit-reducer';
export { ACTION_TYPES };

const SupplierCreateEditContext = createContext<SupplierCreateEditState | undefined>(undefined);
const SupplierCreateEditDispatchContext = createContext({} as any);

export const SupplierCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { supplierId } = useParams();
    const initialState: SupplierCreateEditState = {
        supplierId,
        supplierRequest: { supplierPersonType: 'PJ' },
        showValidationErrors: false,
    };
    const [state, dispatch] = useReducer(SupplierCreateEditReducer, initialState);
    return (
        <SupplierCreateEditContext.Provider value={state}>
            <SupplierCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </SupplierCreateEditDispatchContext.Provider>
        </SupplierCreateEditContext.Provider>
    );
};

export const useSupplierCreateEditState = () => {
    const context = useContext(SupplierCreateEditContext);
    if (!context) throw new Error('useSupplierCreateEditState must be used within SupplierCreateEditProvider');
    return context;
};

export const useSupplierCreateEditDispatch = () => {
    const context = useContext(SupplierCreateEditDispatchContext);
    if (!context) throw new Error('useSupplierCreateEditDispatch must be used within SupplierCreateEditProvider');
    return context;
};
